import { render, staticRenderFns } from "./goods-info.vue?vue&type=template&id=6a7cde8c&scoped=true"
import script from "./goods-info.vue?vue&type=script&lang=js"
export * from "./goods-info.vue?vue&type=script&lang=js"
import style0 from "./goods-info.vue?vue&type=style&index=0&id=6a7cde8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7cde8c",
  null
  
)

export default component.exports